import _typeof from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _readOnlyError from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/readOnlyError.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import moment from 'moment-timezone';
import { formatMoney, parseTime } from "@/utils/util.js";
import dateRange from '@/components/newdaterange/index.vue';
import { getOrderList, updateOrderStatus, exportOrder, updateOrderSendDate, addOrderNote, CancelOrder, getSellerOptions, syncErpOrders, syncOrders } from '@/services/order/orderList';
import { getPaymentDropdownList } from '@/services/systemsetting';
import { getMerchantChannelList } from '@/services/labelingManagement.js';
import axios from 'axios';
export default {
  name: 'orderList',
  i18n: require('./i18n-orderList'),
  components: {
    dateRange: dateRange
  },
  watch: {
    '$route.query.orderStatus': function $routeQueryOrderStatus() {
      if (this.$route.query.orderStatus) {
        this.queryParam.page = 1;
        this.queryParam.size = 20;
        this.queryParam.total = 0;
        this.queryParam.sort = "0";
        this.queryParam.condition.startOrderDate = '';
        this.queryParam.condition.endOrderDate = '';
        this.queryParam.condition.orderStatuss = [];
        this.queryParam.condition.orderStatuss = this.queryParam.condition.orderStatuss.slice(this.queryParam.condition.orderStatuss.length);
        this.queryParam.condition.orderStatuss.push(this.$route.query.orderStatus + "");
        this.$refs.orderDate.clear();
        this.$refs.ArriveDate.clear();
        this.loadList();
      }
    }
  },
  data: function data() {
    return {
      //页面加载完毕事件
      pageLoad: false,
      //订单状态
      orderStatusList: [{
        id: 1,
        name: this.$t('public.orderStatus1')
      }, {
        id: 2,
        name: this.$t('public.orderStatus2')
      }, {
        id: 3,
        name: this.$t('public.orderStatus3')
      }, {
        id: 4,
        name: this.$t('public.orderStatus4')
      }, {
        id: 5,
        name: this.$t('public.orderStatus5')
      }, {
        id: 6,
        name: this.$t('public.orderStatus6')
      }, {
        id: 7,
        name: this.$t('public.orderStatus7')
      }],
      // 货运方式
      deliveryMethodList: [{
        id: 0,
        name: this.$t('orderList.deliveryMethod1')
      }, {
        id: 2,
        name: this.$t('orderList.deliveryMethod2')
      }, {
        id: 1,
        name: this.$t('orderList.deliveryMethod3')
      }],
      // 支付方式
      payMethodList: [{
        id: 1,
        name: this.$t('orderList.payMethod1')
      }, {
        id: 0,
        name: this.$t('orderList.payMethod2')
      }, {
        id: 2,
        name: this.$t('orderList.payMethod3')
      }],
      ddzList: [],
      //搜索条件展开状态
      advanced: false,
      mergeOrderNo: '',
      mergeOrderid: '',
      //支付方式
      paymentList: [],
      mergeVisible: false,
      //发货渠道
      deliveryChannelList: [],
      //查询条件
      queryParam: {
        page: 1,
        size: 20,
        sort: "0",
        condition: {}
      },
      total: 0,
      //table 多选状态
      selectedRowKeys: [],
      orderList: [],
      sortedInfo: {},
      isTableLoading: false,
      //修改订单状态
      orderStatustVisible: false,
      orderStatusRules: {
        status: [{
          required: true,
          message: this.$t("orderList.editOrderStatusNoStatus"),
          trigger: 'change'
        }]
      },
      orderStatusModalValue: {
        noticeCustomer: '1',
        status: '',
        orderNoList: []
      },
      //预计发货日
      orderSendDateOrderNo: "",
      orderSendDateVisible: false,
      orderSendDateModalValue: {
        date: ""
      },
      orderSendDateRules: {
        date: [{
          required: true,
          message: this.$t("orderList.sendDateNoDate"),
          trigger: 'change'
        }]
      },
      //客服备注
      orderNoteVisible: false,
      orderNoteModalValue: {
        note: ""
      },
      orderNoteRules: {
        note: [{
          required: true,
          message: this.$t("orderList.sendDateNoDate"),
          trigger: 'change'
        }]
      },
      rightCurrencySymbol: localStorage.rightCurrencySymbol,
      leftCurrencySymbol: localStorage.leftCurrencySymbol,
      saveLoading: false,
      syncLoading: false // 同步订单 loading
    };
  },
  computed: {
    columns: function columns() {
      var sortedInfo = this.sortedInfo;
      sortedInfo = sortedInfo || {};
      var columns = [{
        //订单编号传票番号
        dataIndex: 'orderNo',
        key: 'orderNo',
        // fixed: 'left',
        scopedSlots: {
          title: "orderNoTitle",
          customRender: 'orderNo'
        },
        width: 80
      }, {
        //客户信息
        title: this.$t('orderList.colCustomer'),
        dataIndex: 'customerAccount',
        key: 'customer',
        width: 150,
        scopedSlots: {
          customRender: 'customer'
        }
      },
      // 担当者
      {
        title: this.$t('orderList.ddz'),
        dataIndex: 'sellerName',
        key: 'sellerName',
        width: 150
      }, {
        //订单状态
        // title: this.$t('orderList.colOrderStatus'),
        dataIndex: 'orderStatus',
        key: 'orderStatus',
        width: 150,
        scopedSlots: {
          title: "orderStatusTitle",
          customRender: 'orderStatus'
        },
        sorter: true,
        sortOrder: sortedInfo.order
      }, {
        //支付方式
        title: this.$t('orderList.payId'),
        dataIndex: 'payTitle',
        key: 'payTitle',
        width: 100
      },
      //语言/渠道

      // title: this.$t('orderList.ColLangTitle'),
      // {
      // 	dataIndex: 'ColLangTitle',
      // 	key: 'ColLangTitle',
      // 	width: 80,
      // 	scopedSlots: {
      // 		title:'ColLangTitle',
      // 		customRender: 'ColLang',
      // 	},
      // },
      // {//下单日期
      // 	// title: this.$t('orderList.colOrderDate'),
      // 	dataIndex: 'orderDate',
      // 	key: 'orderDate',
      // 	width: '100px',

      // },
      {
        //指定到货日期
        // title: this.$t('orderList.ColArriveDate'),
        dataIndex: 'arriveDate',
        key: 'arriveDate',
        width: 110,
        scopedSlots: {
          title: "arriveDateTitle",
          customRender: 'arriveDate'
        },
        align: 'center'
      },
      // {//预计发货日
      // 	// title: this.$t('orderList.colPlanSendTime'),
      // 	dataIndex: 'planSendTime',
      // 	key: 'planSendTime',
      // 	width: '100px',
      // },
      {
        //客户备注
        title: this.$t('orderList.colCustomerNote2'),
        dataIndex: 'customerNote',
        key: 'customerNote',
        scopedSlots: {
          customRender: 'customerNote'
        },
        width: 110,
        ellipsis: true
      },
      //客服备注
      // {
      // 	title: this.$t('orderList.colOperatorNote'),
      // 	dataIndex: 'orderServiceNote',
      // 	key: 'orderServiceNote',
      // 	scopedSlots: {
      // 		customRender: 'orderServiceNote',
      // 	},
      // 	width: 110,
      // 	ellipsis: true,
      // },
      // 合并主订单

      {
        //客户端类型
        //title: this.$t('orderList.colOrderSource'),
        dataIndex: 'orderSource',
        key: 'orderSource',
        width: 90,
        scopedSlots: {
          title: 'orderSourceTitle',
          customRender: 'orderSource'
        },
        ellipsis: true
      }, {
        //操作
        title: this.$t('publicuse.action'),
        dataIndex: 'action',
        key: 'action',
        // fixed: 'right',
        scopedSlots: {
          customRender: 'action'
        },
        width: 100
      }];
      return columns;
    }
  },
  mounted: function mounted() {
    //区分运营方式
    this.deliveryChannel = localStorage.getItem('deliveryChannel');
    if (this.deliveryChannel == 1) {
      var item = {
        dataIndex: 'ColLangTitle',
        key: 'ColLangTitle',
        width: 80,
        scopedSlots: {
          title: 'ColLangTitle',
          customRender: 'ColLang'
        }
      };
      this.columns.splice(5, 1, item);
    }
    var self = this;
    if (self.$route.query.orderStatus) {
      self.queryParam.condition.orderStatuss.push(self.$route.query.orderStatus + "");
    } else {
      self.queryParam.condition.endOrderDate = moment().format('YYYY-MM-DD');
      self.queryParam.condition.startOrderDate = moment().add(-1, 'M').format('YYYY-MM-DD');
    }
    self.loadData();
    self.loadList();
    self.pageLoad = true;
  },
  methods: {
    /**
     * 同步订单
     * @return {Promise<void>}
     */
    syncOrder: function syncOrder() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var resOrder, resErpOrder;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.syncLoading = true;
              _context.p = 1;
              _context.n = 2;
              return syncOrders();
            case 2:
              resOrder = _context.v;
              if (resOrder.data.code == 200) {
                _this.$message.success(_this.$t('public.updateSuccessfully'));
                _this.loadList();
              }
              _context.n = 3;
              return syncErpOrders();
            case 3:
              resErpOrder = _context.v;
            case 4:
              _context.p = 4;
              _this.syncLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1,, 4, 5]]);
      }))();
    },
    loadData: function loadData() {
      var _this2 = this;
      //获取所有支付方式
      // getPaymentDropdownList(2).then(response=>{
      // 	if(response.data.code==200){
      // 	this.paymentList = response.data.data
      // 	}
      // })
      //获取所有发货渠道
      if (this.deliveryChannel == 1) {
        getMerchantChannelList({
          statusType: 2
        }).then(function (response) {
          if (response.data.code == 200) {
            _this2.deliveryChannelList = response.data.data;
          }
        });
      }
      // 获取所有的担当者
      getSellerOptions({
        scene: 0
      }).then(function (res) {
        if (res.data.code == 200) {
          _this2.ddzList = res.data.data.map(function (item) {
            return {
              id: item.sellerCode,
              name: item.sellerName
            };
          });
        }
      });
    },
    loadList: function loadList() {
      var self = this;
      var newParam = _.cloneDeep(self.queryParam);
      newParam.condition.payId = self.queryParam.condition.payId && self.queryParam.condition.payId.join(",");
      newParam.condition.orderStatus = self.queryParam.condition.orderStatus && self.queryParam.condition.orderStatus.join(",");
      // newParam.condition.deliveryChannelId = self.queryParam.condition.deliveryChannelIds && self.queryParam.condition.deliveryChannelIds.join(",");
      newParam.condition.deliveryWays = self.queryParam.condition.deliveryWays && self.queryParam.condition.deliveryWays.join(",");
      newParam.condition.sellerCode = self.queryParam.condition.sellerCode && self.queryParam.condition.sellerCode.join(",");
      self.isTableLoading = true;
      getOrderList(newParam).then(function (response) {
        if (response.data.code == 200) {
          self.selectedRowKeys = [];
          self.orderList = response.data.data.list;
          self.total = response.data.data.totalNum;
        }
      }).finally(function () {
        self.isTableLoading = false;
      });
    },
    query: function query() {
      this.queryParam.page = 1;
      // if ( this.$route.query.orderStatus ) {
      //   this.$router.replace({ query: {} });
      // }
      this.loadList();
    },
    //下单日期日期处理
    changeOrderDate: function changeOrderDate(dateRange) {
      //console.log(typeof(dateRange.endDateClone),typeof(dateRange.startDateClone))
      if (dateRange.startDateClone != undefined) {
        if (_typeof(dateRange.startDateClone) == "object") {
          this.queryParam.condition.startOrderDate = parseTime(dateRange.startDateClone._d, "{y}-{m}-{d}");
        } else {
          this.queryParam.condition.startOrderDate = dateRange.startDateClone;
        }
      } else {
        this.queryParam.condition.startOrderDate = "";
      }
      if (dateRange.endDateClone != undefined) {
        if (_typeof(dateRange.endDateClone) == "object") {
          this.queryParam.condition.endOrderDate = parseTime(dateRange.endDateClone._d, "{y}-{m}-{d}");
        } else {
          this.queryParam.condition.endOrderDate = dateRange.endDateClone;
        }
      } else {
        this.queryParam.condition.endOrderDate = "";
      }
    },
    // 指定到货日期处理
    changeArriveDate: function changeArriveDate(dateRange) {
      if (dateRange.startDateClone != undefined) {
        this.queryParam.condition.startArriveDate = parseTime(dateRange.startDateClone._d, "{y}-{m}-{d}");
      } else {
        this.queryParam.condition.startArriveDate = "";
      }
      if (dateRange.endDateClone != undefined) {
        this.queryParam.condition.endArriveDate = parseTime(dateRange.endDateClone._d, "{y}-{m}-{d}");
      } else {
        this.queryParam.condition.endArriveDate = "";
      }
    },
    //订单状态修改确定 事件
    orderStatustHandle: function orderStatustHandle() {
      var _this3 = this;
      var self = this;
      if (!this.saveLoading && this.orderStatustVisible) {
        this.$refs.orderStatusRuleForm.validate(function (valid) {
          if (valid) {
            _this3.orderStatusModalValue.orderNoList = _this3.selectedRowKeys;
            _this3.saveLoading = true;
            updateOrderStatus(_this3.orderStatusModalValue).then(function (response) {
              if (response.data.code == 200) {
                var data = response.data.data;
                //如果返回的内容中有没有修改成功的订单，会返回错误提示语
                if (data && data.errorMsg) {
                  self.$notification.error({
                    message: data.errorMsg
                  });
                } else {
                  _this3.$message.success(_this3.$t('public.updateSuccessfully'));
                }
                _this3.orderStatustVisible = false;
                _this3.loadList();
                _this3.orderStatusModalValue = {
                  noticeCustomer: '1',
                  status: '',
                  orderNoList: []
                };
              }
              _this3.saveLoading = false;
            });
          }
        });
      }
    },
    //订单导出按钮事件
    btnOrderExport: function btnOrderExport() {
      var _this4 = this;
      if (!this.saveLoading) {
        axios.defaults.timeout = 50000;
        axios.defaults.withCredentials = true;
        this.saveLoading = true;
        axios.get(process.env.VUE_APP_API_BASE_URL + "/order/export", {
          responseType: 'blob',
          headers: {
            'x-auth-token': 888
          },
          params: {
            orderNos: this.selectedRowKeys.join(",")
          }
        }).then(function (res) {
          console.log(res);
          if (res.data.type === 'application/json') {
            //错误提示
            var reader = new FileReader();
            // 处理load事件。该事件在读取操作完成时触发
            reader.onload = function (e) {
              var res = JSON.parse(e.target.result);
              console.log(res);
              _this4.$message.error(res.message); //异常信息抛出
            };
            reader.readAsText(res.data);
          } else {
            var blob = new Blob([res.data], {
              type: 'application/csv'
            });
            // const url = window.URL.createObjectURL(blob)

            var elink = document.createElement('a');
            elink.download = "orderExport_".concat(parseTime(new Date().getTime(), "{y}{m}{d}{h}{i}{s}"), ".csv");
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
            // window.location.href = url
          }
          _this4.saveLoading = false;
        }).catch(function (err) {
          _this4.$message.error(err);
          _this4.saveLoading = false;
        });
      }
    },
    //订单物流刷新按钮事件
    btnOrderExpress: function btnOrderExpress() {},
    //预计发货日按钮事件
    orderSendDateHandle: function orderSendDateHandle() {
      var _this5 = this;
      if (this.orderSendDateVisible && !this.saveLoading) {
        this.$refs.orderSendDateRuleForm.validate(function (valid) {
          if (valid) {
            _this5.orderSendDateModalValue.noList = _this5.selectedRowKeys;
            _this5.saveLoading = true;
            updateOrderSendDate(_this5.orderSendDateModalValue).then(function (response) {
              if (response.data.code == 200) {
                _this5.$message.success(_this5.$t('public.updateSuccessfully'));
                _this5.orderSendDateVisible = false;
                _this5.loadList();
                _this5.orderSendDateModalValue = {};
              }
              _this5.saveLoading = false;
            });
          }
        });
      }
    },
    //列表-操作-更多-客服备注
    orderNoteHandle: function orderNoteHandle() {
      var _this6 = this;
      if (this.orderNoteVisible && !this.saveLoading) {
        this.$refs.orderNoteRuleForm.validate(function (valid) {
          if (valid) {
            _this6.orderNoteModalValue.noList = _this6.orderSendDateOrderNo;
            _this6.saveLoading = true;
            addOrderNote(_this6.orderNoteModalValue).then(function (response) {
              if (response.data.code == 200) {
                _this6.$message.success(_this6.$t('public.updateSuccessfully'));
                _this6.orderNoteVisible = false;
                _this6.loadList();
                _this6.orderNoteModalValue = {};
              }
              _this6.saveLoading = false;
            });
          }
        });
      }
    },
    //列表-操作-更多-取消
    orderCancel: function orderCancel(record) {
      var _this7 = this;
      if (record.cancelOrderLoading) return;
      record.cancelOrderLoading = true;
      CancelOrder("orderNo=".concat(record.orderNo)).then(function (response) {
        if (response.data.code == 200) {
          _this7.$message.success(_this7.$t('orderList.cancelOk'));
          _this7.loadList();
        }
      }).finally(function () {
        record.cancelOrderLoading = false;
      });
    },
    //点击table 时触发，排序用
    tableChange: function tableChange(pagination, filters, sorter, _ref) {
      var currentDataSource = _ref.currentDataSource;
      this.sortedInfo = sorter;
      this.queryParam.page = pagination.current;
      this.queryParam.size = pagination.pageSize;
      if (sorter.columnKey) {
        if (typeof sorter.order == "undefined") {
          sorter.order = "ascend";
        }
        var order = sorter.order == "ascend" ? "1" : "0";
        this.queryParam.sort = order;
      }
      this.loadList();
    },
    //点击table 选择框触发
    onSelectChange: function onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    //绑定物流数据使用数据
    jsonParse: function jsonParse(data) {
      if (data) {
        return JSON.parse(data);
      } else {
        return [];
      }
    },
    // 详情
    goDetail: function goDetail(row) {
      var newLo = this.$router.resolve({
        name: 'orderDetail',
        query: {
          id: row.id
        }
      });
      window.open(newLo.href, '_blank');
    }
  }
};